import React from 'react';

const AllTaskPage: React.FC = () => {
    return (
        <div>
            AllTaskPage
        </div>
    );
};

export { AllTaskPage }
